<template>
  <div
    v-bind:class="{
      'hot-game-push': true,
      'ani-time': aniTime,
      loaded: loaded,
      expand: expand,
    }"
    ref="hotGamePush"
    v-bind:style="{ transform: wrapperY, height: wrapperHeight }"
  >
    <v-mask
      v-show="expand"
      style="background: none"
      @touchmove="gtouchmove"
      @click="handleToggle"
    ></v-mask>
    <div ref="menuList" class="menu-list">
      <img
        ref="menuBgImgVertical"
        src="@/assets/img/hot-game-push/UI_RMYX_BG_01_1.png"
        ondragstart="return false;"
        @touchmove="gtouchmove"
        v-if="style == 1"
      />
      <img
        v-else
        ref="menuBgImgVertical"
        src="@/assets/style2/img/hot-game-push/UI_RMYX_BG_01_1.png"
        ondragstart="return false;"
        @touchmove="gtouchmove"
      />
      <div class="game-list customizeVertical" v-bind:style="gameListStyle" ref="gameList">
        <div class="game-list-box">
          <scale-box
            v-for="(item, i) in gameList"
            v-bind:key="i"
            v-bind:style="imgBoxStyle"
            class="img-box"
            @click="handleJump(item)"
            v-preventReClick="2000"
            v-clickMusic
            :gamePic="item.game_pic"
            :w="itemImgw"
            :h="itemImgh"
            :left="itemImgLeft"
          ></scale-box>
        </div>
      </div>
    </div>
    <div
      v-bind:class="{
        toggle: style == 1,
        'toggle-style2': style != 1,
        'toggle-status1': !expand,
        'toggle-status2': expand,
      }"
      @click="handleToggle"
      v-clickMusic
      v-bind:style="{ transform: toggleTop, top: y + 'px', right: toggleRight }"
    ></div>
  </div>
</template>

<script>
import { jumpGameByGameID, reportUserBehavior } from "@/logic/src/common";
import vmask from "@/components/mask.vue";
import scaleBox from "./scaleBoxVertical.vue";
import BScroll from "@better-scroll/core";
import store from "@/store/index";
import { getHotGamePush } from "@/api/task";
export default {
  name: "dialogNotice",
  components: {
    "v-mask": vmask,
    scaleBox,
  },
  data() {
    return {
      style: store.state.app.appInfo.style,
      gameID: 0,
      gameList: [],
      y: 0,
      toggleTop: "translateY(0px)",
      toggleRight: "0.85rem",
      wrapperY: "translateY(0px)",
      wrapperHeight: "auto",
      expand: false,
      aniTime: false,
      gameListStyle: {
        right: "0.22rem",
        bottom: "0.07rem",
        left: "0.07rem",
      },
      imgBoxStyle: {
        height: "1.05rem",
        width: "0.65rem",
      },
      itemImgh: "0.65rem",
      itemImgw: "1.05rem",
      itemImgLeft: "-0.2rem",
      gameListScroller: null,
      loaded: false,
    };
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
    areaSize() {
      return store.state.app.areaSize;
    },
    platform() {
      return store.state.app.platform;
    },
    toggleLeftValue() {
      if (this.style == 1) {
        return 0.06;
      } else {
        return 0.03;
      }
    }
  },
  mounted() {
    this.setGameListScroller();
    this.$refs.menuBgImgVertical.addEventListener("load", () => {
      this.$nextTick(() => {
        this.resetBtnX();
        this.resetToggleX();
        this.getData();
      });
    });
  },
  watch: {
    closeAllPopUp(val) {
      if (this.expand && val.key != "hotGamePush") {
        this.handleToggle();
      }
    },
    areaSize() {
      this.aniTime = false;
      this.$nextTick(() => {
        this.resetBtnX();
        this.resetToggleX();
      });
    },
    expand() {
      this.$nextTick(() => {
        this.resetToggleX();
        this.resetBtnX();
      });
    },
    imgBoxStyle() {
      this.itemImgh = this.imgBoxStyle.width;
      this.itemImgw = this.imgBoxStyle.height;
      this.itemImgLeft = `-${
        (Number(this.itemImgw.replace("rem", "")) -
          Number(this.itemImgh.replace("rem", ""))) /
        2
      }rem`;
    },
  },
  methods: {
    //获取数据
    getData() {
      getHotGamePush({
        game_id: this.gameID,
        identity: store.state.app.appInfo.identity,
      }).then((res) => {
        res = res.data;
        if (res.code == 0 && res.result.data.length > 0) {
          this.gameList = res.result.data;
          this.loaded = true;
          this.$nextTick(() => {
            if (this.gameListScroller != null) {
              this.gameListScroller.refresh();
            }
          });
        } else {
          if (window._hotGamePush != null) {
            window._hotGamePush.close();
            window._hotGamePush = null;
          }
        }
      });
    },
    //设置滚动区域
    setGameListScroller() {
      if (this.gameListScroller != null) {
        this.gameListScroller.destroy();
        this.gameListScroller = null;
      }
      this.gameListScroller = new BScroll(this.$refs.gameList, {
        click: true,
        scrollX: true,
        scrollY: false,
      });
    },
    //重新设置toggle的位置
    resetToggleX() {
      if (this.expand) {
        this.wrapperY = "translateY(0px)";
        this.wrapperHeight = "100%";
      } else {
        this.wrapperY = `translateY(-${this.y}px)`;
        this.wrapperHeight = "auto";
      }
    },
    //重新设置btn的位置
    resetBtnX() {
      if (this.$refs.menuBgImgVertical) {
        this.y = window
          .getComputedStyle(this.$refs.menuBgImgVertical, null)
          .height.split("px")[0];
        this.resetScaleSize();
      }
    },
    //重置适配尺寸
    resetScaleSize() {
      const h = window.document.documentElement.getBoundingClientRect().width;
      const scale = h / 720;
      if (this.expand) {
        if (h > 720) {
          this.toggleTop = `translateY(${-this.toggleLeftValue * scale}rem)`;
          this.gameListStyle = {
            right: `${0.22 * scale}rem`,
            bottom: `${0.07 * scale}rem`,
            left: `${0.07 * scale}rem`,
          };
          this.imgBoxStyle = {
            height: `${1.05 * scale}rem`,
            width: `${0.65 * scale}rem`,
          };
          this.toggleRight = `${0.85 * scale}rem`;
        } else {
          this.toggleTop = `translateY(-${this.toggleLeftValue}rem)`;
          this.gameListStyle = {
            right: "0.22rem",
            bottom: "0.07rem",
            left: "0.07rem",
          };
          this.imgBoxStyle = {
            height: "1.05rem",
            width: "0.65rem",
          };
          this.toggleRight = "0.85rem";
        }
        this.$nextTick(() => {
          if (this.gameListScroller != null) {
            this.gameListScroller.refresh();
          }
        });
      } else {
        this.toggleTop = "translateY(0px)";
        if (h > 720) {
          this.toggleRight = `${0.85 * scale}rem`;
        } else {
          this.toggleRight = "0.85rem";
        }
      }
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    handleToggle() {
      this.aniTime = true;
      this.$nextTick(() => {
        this.expand = !this.expand;
        if (this.expand) {
          store.dispatch("setCloseAllPopUp", "hotGamePush");
        }
      });
    },
    reset() {
      this.expand = false;
      this.$nextTick(() => {
        this.remove();
      });
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
    handleJump(item) {
      const gameId = item.game_id;
      this.handleToggle();
      //行为上报
      reportUserBehavior(this.gameID, 0, 8004, gameId);
      jumpGameByGameID(gameId);
      // //web
      // if (this.platform == 0) {
      //   ifmTool.closeGame();
      //   store.dispatch("setOpenGameID", gameId);
      // }
      // //app
      // else {
      //   initApp(gameId, true).then((res) => {
      //     window.nativeUtils.getGameInfo(gameId).then((e) => {
      //       if (e) {
      //         const gameInfo = JSON.parse(e);
      //         if (gameInfo.version) {
      //           if (
      //             parseInt(String(gameInfo.version).split(".").join("")) ==
      //             parseInt(String(res.version).split(".").join(""))
      //           ) {
      //             store.dispatch("setOpenGameUrl", gameInfo.native_url);
      //             ifmTool.closeGame();
      //           } else {
      //             this.$toast("这个游戏还没有更新，请返回大厅进行更新");
      //           }
      //         } else {
      //           this.$toast("这个游戏还没有下载，请返回大厅进行下载");
      //         }
      //       } else {
      //         this.$toast("这个游戏还没有下载，请返回大厅进行下载");
      //       }
      //     });
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.hot-game-push {
  position: fixed;
  display: block;
  z-index: 10000;
  visibility: hidden;
  left: 0;
  top: 0;
  width: 100%;
  &.expand {
    z-index: 10001;
  }
  &.loaded {
    visibility: visible;
  }
  &.ani-time {
    transition-duration: 0.2s;
  }
  .menu-list {
    position: absolute;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
    .game-list {
      position: absolute;
      display: block;
      top: 0;
      right: 0;
      direction: rtl;
      overflow: hidden;
      .game-list-box {
        display: table;
        white-space: nowrap;
        .img-box {
          height: 1.05rem;
          width: 0.65rem;
          cursor: pointer;
          display: table-cell;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .toggle {
    position: absolute;
    height: 0.26rem;
    width: 0.915rem;
    display: block;
    z-index: 99999;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &.toggle-status1 {
      background: url(~@/assets/img/hot-game-push/UI_RMYX_biaoqian_01_1.png)
        no-repeat;
      background-size: contain;
    }
    &.toggle-status2 {
      background: url(~@/assets/img/hot-game-push/UI_RMYX_biaoqian_02_1.png)
        no-repeat;
      background-size: contain;
    }
  }

  .toggle-style2 {
    position: absolute;
    height: 0.26rem;
    width: 0.915rem;
    display: block;
    z-index: 99999;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &.toggle-status1 {
      background: url(~@/assets/style2/img/hot-game-push/UI_RMYX_biaoqian_01_1.png)
        no-repeat;
      background-size: contain;
    }
    &.toggle-status2 {
      background: url(~@/assets/style2/img/hot-game-push/UI_RMYX_biaoqian_02_1.png)
        no-repeat;
      background-size: contain;
    }
  }
}
</style>